import { render, staticRenderFns } from "./NoTenant.vue?vue&type=template&id=0c555740"
import script from "./NoTenant.vue?vue&type=script&lang=ts"
export * from "./NoTenant.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports